var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var SsoController = {
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/samlMetadata/{appId}/{keyFormat?}" and http method "GET" to call the back-end.
    
        * @param {string} appId
        * @param {string} keyFormat
        * @returns {string}
    ******************************************************************************************************/
    GetSamlMetadata: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/samlMetadata/{appId}/{keyFormat?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/logoutApplications/{appId}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @returns {string}
    ******************************************************************************************************/
    LogoutApplications: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/logoutApplications/{appId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/requestSamlLogin/{provider}/{appId?}/{rawReturnRoute?}" and http method "GET" to call the back-end.
    
        * @param {string} provider
        * @param {string} appId
        * @param {string} rawReturnRoute
        * @returns {void}
    ******************************************************************************************************/
    RequestSamlToken: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/requestSamlLogin/{provider}/{appId?}/{rawReturnRoute?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/requestSamlLoginConfigured/{providerId}" and http method "GET" to call the back-end.
    
        * @param {string} providerId
        * @returns {void}
    ******************************************************************************************************/
    RequestSamlTokenConfigured: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/requestSamlLoginConfigured/{providerId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/addSsoApp" and http method "POST" to call the back-end.
    
        * @param {SsoApplicationUploadDto} app
        * @returns {SsoApplicationDownloadDto}
    ******************************************************************************************************/
    AddSsoApplication: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/addSsoApp", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.app
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/samlTokenRedirect/{appId}/{target?}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @param {string} target
        * @param {string} authnRequestBase64
        * @returns {SamlTokenRedirect}
    ******************************************************************************************************/
    GetSamlTokenRedirect: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.authnRequestBase64 !== undefined)
            fd.append("authnRequestBase64", JSON.stringify(data.authnRequestBase64));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/samlTokenRedirect/{appId}/{target?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/loginSso/{appId}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @param {LoginDto} login
        * @param {BrowserInfo} browserInfo
        * @returns {LoginResultDto}
    ******************************************************************************************************/
    LoginSso: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("login", JSON.stringify(data.login));
        fd.append("browserInfo", JSON.stringify(data.browserInfo));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/loginSso/{appId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login/token/renew/sso/{appId}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @returns {string}
    ******************************************************************************************************/
    RenewToken: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/token/renew/sso/{appId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/logoutSso/{appId}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @returns {void}
    ******************************************************************************************************/
    Logout: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/logoutSso/{appId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/loginSso/reset/{appId}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @param {LoginDto} login
        * @returns {void}
    ******************************************************************************************************/
    LoginReset: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/loginSso/reset/{appId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.login
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/resetSso/{appId}/{encodedString}" and http method "GET" to call the back-end.
    
        * @param {string} appId
        * @param {string} encodedString
        * @returns {string}
    ******************************************************************************************************/
    Reset: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/resetSso/{appId}/{encodedString}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/loginSso/password/{appId}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @param {LoginDto} login
        * @returns {string}
    ******************************************************************************************************/
    ChangePassword: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/loginSso/password/{appId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.login
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login/saml/{providerId}/{appId?}/{route?}" and http method "POST" to call the back-end.
    
        * @param {string} providerId
        * @param {string} appId
        * @param {string} route
        * @returns {string}
    ******************************************************************************************************/
    LoginSaml: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/saml/{providerId}/{appId?}/{route?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/sso/providersForApp/{appId}" and http method "GET" to call the back-end.
    
        * @param {string} appId
        * @returns {SsoProviderDownloadDto[]}
    ******************************************************************************************************/
    GetProvidersForApp: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/sso/providersForApp/{appId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/sso/appInfo/{appId}" and http method "GET" to call the back-end.
    
        * @param {string} appId
        * @returns {SsoAppInfo}
    ******************************************************************************************************/
    GetAppInfo: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/sso/appInfo/{appId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/sso/logoutRedirect/{appId}" and http method "GET" to call the back-end.
    
        * @param {string} appId
        * @returns {string}
    ******************************************************************************************************/
    AfterLogoutRedirect: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/sso/logoutRedirect/{appId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/sso/create2faRegistration/{appId}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @param {LoginDto} login
        * @returns {string}
    ******************************************************************************************************/
    Create2faRegistration: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("login", JSON.stringify(data.login));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/sso/create2faRegistration/{appId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/sso/request2faRegistrationReplacement/{appId}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @returns {string}
    ******************************************************************************************************/
    RequestReplacement2faRegistration: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/sso/request2faRegistrationReplacement/{appId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/sso/confirmReplacement2faRegistration/{appId}/{totp}" and http method "POST" to call the back-end.
    
        * @param {string} appId
        * @param {string} totp
        * @returns {boolean}
    ******************************************************************************************************/
    ConfirmReplacement2faRegistration: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/sso/confirmReplacement2faRegistration/{appId}/{totp}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login/marketList" and http method "POST" to call the back-end.
    
        * @param {File} marketsFile
        * @returns {void}
    ******************************************************************************************************/
    UpdateMarketList: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.marketsFile)
            fd.append("marketsFile", data.marketsFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/marketList", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=SsoController.js.map